import { ErrorBase } from "algoliasearch/lite";
import { Axios, HttpStatusCode } from "axios";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import { createFrequentlyBoughtTogetherQueries } from "@services/algolia/recommend/helpers/query.helpers";
import { getProductsFromResponse } from "@services/algolia/recommend/helpers/response.helpers";
import { ParamsAlgolia } from "@services/algolia/types/paramsAlgolia.types";

import { generateAlgoliaParameters } from "@redux/modules/value/search/search.actions";
import { IState } from "@redux/store.types";

import { ProductAlgoliaModel } from "lib/@types/service/product/algolia/product.algolia.model";

import { AlgoliaClient } from "../types/client.types";

const getRecommendations =
    (
        algoliaClient: AlgoliaClient,
        dispatch: ThunkDispatch<IState, Axios, Action>,
    ) =>
    (objectIDs: Array<string>, paramsAlgolia: ParamsAlgolia) => {
        const queries = createFrequentlyBoughtTogetherQueries(
            objectIDs,
            paramsAlgolia,
        );

        return algoliaClient
            .getRecommendations<ProductAlgoliaModel>({ requests: queries })
            .then(getProductsFromResponse(paramsAlgolia.limit, objectIDs))
            .catch((error: ErrorBase) => {
                if (
                    error.status === HttpStatusCode.BadRequest ||
                    error.status === HttpStatusCode.Forbidden
                ) {
                    dispatch(generateAlgoliaParameters());
                }

                throw error;
            });
    };

export { getRecommendations };
